jQuery(document).ready(function($) {
    const elm = $('.show-if-not-chrome');
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    elm.toggle(!isChrome);
});
